  import React from "react";

  const CancellationPolicy = () => {

  return (
        <div className="xl:px-[calc((100%-1250px)/2)] px-3 mt-60 mb-20">
      <h1 className="text-3xl font-bold text-[#2A668D] mb-4">Cancellation Policy</h1>
      <p className="mb-4">
        At Wehelpufirst, we strive to provide flexible and fair cancellation terms for
        both users and service providers.
      </p>

      <ol className="list-decimal ml-6 space-y-2">
        <li>
          <strong>User Cancellations:</strong> Users can cancel bookings up to 12 hours
          before the scheduled service for a full refund.
        </li>
        <li>
          <strong>Vendor Cancellations:</strong> Vendors are expected to notify users
          immediately if cancellation is necessary.
        </li>
        <li>
          <strong>Refunds:</strong> Refunds for eligible cancellations are processed within
          7 business days.
        </li>
        <li>
          <strong>Dispute Resolution:</strong> In case of disagreements, our support team
          will mediate fairly.
        </li>
      </ol>

      <p className="mt-6">
        Please review the terms regularly. Continued use implies acceptance of any
        changes to this policy.
      </p>
    </div>
  );
};
export default CancellationPolicy;